export default __webpack_public_path__ + "06e8287de16f1e4844a78d0427ce6107.png";